import React, { useEffect } from 'react'
import styled from 'styled-components'
import { NavBar } from '../../components/navbar'
import { Footer } from '../../components/footer'
import { SearchInput } from '../../components/input'
import { AiOutlinePlus, AiOutlineMinus } from 'react-icons/ai'
import { IoChevronBack, IoChevronForwardSharp } from 'react-icons/io'
import { MdOutlineArrowBackIosNew, MdArrowForwardIos } from 'react-icons/md'
import { Accordion } from '../../components/accordion'
import { AllBooksCard } from '../../components/allpubbooks'
import { allPubData } from '../../allpubdata'


const AdvancedSearch = () => {

    useEffect(() => {
        window.history.scrollRestoration = 'manual'
      }, []);
  return (
    <Container>
        <NavBar />
            {/* <HeroSection>
                <div>
                    <h2>National Virtual library Search</h2>
                    <p>Find information and abstracts of more than 100,000 collection resources, including over 50,000 online materials</p>
                    <SearchInput />
                </div>
                
            </HeroSection> */}

            <BodyContainer>
            <InnerBodyContainer>
                    {/* <p>Your search discovered 4000 resources</p> */}
                    <Accordion />

                    {
                        allPubData.slice(0, 10).map((pub) => {
                            return(
                                <AllBooksCard link={pub.link} isbn={pub.isbn} author={pub.author} title={pub.title} journal={pub.journal} pubdate={pub.pubdate} />
                            )
                        }
                    )}
                    

                    <Pagination>
                        <div>  
                            <div> <MdOutlineArrowBackIosNew /> <span> Previous </span> </div>   
                        
                            <p>
                                <ul>
                                    <li> 1 </li>
                                    <li> 2 </li>
                                    <li> 3 </li>
                                    <li> 4 </li>
                                    <li> 5 </li>
                                </ul>
                                    
                            </p>
                            <div>  <span> Next </span> <MdArrowForwardIos /> </div> 
                         </div>
                    </Pagination>
                    
            </InnerBodyContainer>
                
            

            </BodyContainer>
        <Footer />
    </Container>
  )
}

const Container = styled.section`
    width: 100%;
    margin: 0 auto;
`

export const HeroSection = styled.section`
    width: 100%;
    background-color: #EAECF0;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 100px 0 70px 0;

    @media screen and (max-width: 600px){    
        padding: 50px 0 50px 0;
    
    }

    & > div{
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-top: 24px;
        margin: 0 auto;
        width: 80%;
        max-width: 1250px;

        & > h2{

            @media screen and (max-width: 600px){
                
            }
        }

        & > p{
        font-weight: 600;
        color: #667085;
        padding-top: 10px;
        /* padding-bottom: 15px; */


    @media screen and (max-width: 600px){
             font-weight: 400;
            }


        padding-bottom: 20px;
    }
        
    }

   

`

export const BodyContainer = styled.section`
    padding-top: 50px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    max-width: 1250px;
    margin: 0 auto;

    @media screen and (max-width: 600px){
        width: 90%;
    }

    
`

export const InnerBodyContainer = styled.div`
    width: 100%;
    max-width: 1250px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;

    & > p{ 
        align-self: flex-start;
        color: #101828;
        /* padding-left: 5.5rem; */
        padding-bottom: 1.5rem;

        @media screen and (max-width: 600px){
            align-self: flex-start;
            color: #101828;
            padding-left: 1.5rem;
        }
        
    }

`  

export const Pagination = styled.div`
    display: flex;
    width: 80%;
    justify-content: space-between;
    margin-top: 10rem;
    margin-bottom: 5rem;

    @media screen and (max-width: 600px){    
        width: 100%;
        align-items: center;
        margin-top: 5rem;
        margin-bottom: 5rem;
        /* border: 1px solid red; */
        }
    

    & > div{
        display: flex;
        flex-direction: row;
        width: 100%;
        justify-content: space-between;
        align-items: center;
        /* background-color: #2A870E; */

        & :hover{
            /* cursor: progress; */
            opacity: 0.8;
            transition: 0.5s ease-out;
        }
        

        &  p{
            color: #101828;
            padding-left: 1.2rem;
            & > ul{
            display: flex;
            flex-direction: row;

            &  li{
                margin-right: 20px;
                cursor: pointer;
                border: 1px solid #101828;
                
                
                @media screen and (max-width: 600px){    
                /* padding: 12px 20px; */
                font-size: 1.4rem;
        }

                & :hover, :focus {
                    transition: all 0.5s;
                    border-bottom: 1px solid #2A870E;
                }
            }
            }
        
        }

        &  div{

            display: flex;
            align-items: center;
            background-color: #2A870E;
            color: #fff;
            text-align: center;
            padding: 18px 32px;
            cursor: pointer;

            @media screen and (max-width: 600px){    
                padding: 12px 20px;
        }

                &  span{
                font-size: 16px;
                width: fit-content;
                height: fit-content;

                @media screen and (max-width: 600px){
                    display: none;
                }
       
        }

       

        /* & li {
            color: #000;
            font-size: 11px;
        } */
    }
}
`

export {AdvancedSearch}